import { render } from "./LiveMatchScore.vue?vue&type=template&id=ca91da4c&ts=true"
import script from "./LiveMatchScore.vue?vue&type=script&lang=ts"
export * from "./LiveMatchScore.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__